import { SuperViewModalManual } from 'features/withdraw/components/modal/super-admin-manual';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
// ../components/modal/super-admin-manual

export const SuperViewManual = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.SUPER_ADMIN);
  };

  return (
    <SuperViewModalManual id={id} onClose={closeModal} onSuccess={closeModal} />
  );
};
